import {Component, Input, OnInit} from '@angular/core';
import {DomSanitizer} from '@angular/platform-browser';

@Component({
  selector: 'app-cms-notification',
  templateUrl: './cms-notification.component.html',
  styleUrls: ['./cms-notification.component.scss']
})
export class CmsNotificationComponent implements OnInit {

  notificationHtml: string;

  @Input()
  set notificationKey(val) {
    if (window[val]) {
      this.notificationHtml = window[val];
    }
  }

  constructor(private sanitizer: DomSanitizer) { }

  ngOnInit() {
  }

  cmsNotification(): string {
    return this.notificationHtml ? this.sanitizer.bypassSecurityTrustHtml(this.notificationHtml) as string : '';
  }
}
